module.exports = __webpack_public_path__ + "static/media/4ll21.ce9d94e5.png";